import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { ModulesFacade } from '../facades/modules.facade';

export function modulesCleanup<T>(): CanDeactivateFn<T> {
    return () => {
        const modulesFacade = inject(ModulesFacade);
        modulesFacade.clear();

        return true;
    };
}
